export default __webpack_public_path__ + "static/ts-logo-white-developer-dd081fd6d74b25544671da05297eddd8.svg";